import { render, staticRenderFns } from "./MyLeaseRegistrationRequestList.vue?vue&type=template&id=09032d02"
import script from "./MyLeaseRegistrationRequestList.vue?vue&type=script&lang=ts"
export * from "./MyLeaseRegistrationRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports